import React, { Component } from "react";

class Loading extends Component {
  state = {};
  render() {
    return (
      <div
        style={{ marginTop: 20, width: 20, height: 20 , borderWidth: 2 }}
        className="spinner-grow text-success"
        role="status"
      >
        <span className="sr-only"></span>
      </div>
    );
  }
}

export default Loading;
